
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from '@/contexts/AuthContext';

export const useIsDeveloper = () => {
  const { user, session } = useAuth();
  
  return useQuery({
    queryKey: ['user-developer-mode', user?.id], // Include user ID to prevent cross-user cache pollution
    queryFn: async () => {
      console.log('[useIsDeveloper] Checking developer mode for user:', user?.id);
      
      if (!user?.id || !session) {
        console.log('[useIsDeveloper] No user or session, returning false');
        return false;
      }
      
      const { data: profile, error } = await supabase
        .from('profiles')
        .select('developer_mode')
        .eq('id', user.id)
        .single();
      
      if (error) {
        console.error('[useIsDeveloper] Error fetching profile:', error);
        return false;
      }
        
      const isDeveloper = profile?.developer_mode || false;
      console.log('[useIsDeveloper] Developer mode result:', isDeveloper);
      return isDeveloper;
    },
    enabled: !!user?.id && !!session, // Only run query when user is authenticated
    staleTime: 1000 * 60 * 5, // 5 minutes - prevent indefinite caching
    gcTime: 1000 * 60 * 10, // 10 minutes garbage collection
  });
};
